import { render, staticRenderFns } from "./TenantInfoDialog.vue?vue&type=template&id=405958d7&scoped=true"
import script from "./TenantInfoDialog.vue?vue&type=script&lang=ts"
export * from "./TenantInfoDialog.vue?vue&type=script&lang=ts"
import style0 from "./TenantInfoDialog.vue?vue&type=style&index=0&id=405958d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405958d7",
  null
  
)

export default component.exports